import * as React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import { VerificationService,
         SuccessResponse,
         closeTabRef,
         CopyToClipboard,
} from '@sheerid/jslib';
import { getMetadataByKey, getQueryParamsByName } from '../../../metadataQueryString';

interface StepSuccessProps {
    verificationService: VerificationService;
}

const redirect = (redirectDestination: string) => {
    const win = window.open(redirectDestination, '_parent');
    win.focus();
};

const StepSuccessComponent = ({ verificationService }: StepSuccessProps) => {
    // Close any open tab for SSO login
    closeTabRef();

    const country = getMetadataByKey(verificationService, 'country') || getQueryParamsByName('country');
    const rewardCode = (verificationService.verificationResponse as SuccessResponse).rewardCode || '${rewardCode}';

    let redirectUrl = 'https://www.thenorthface.com';
    if (country === 'CA') {
        redirectUrl = 'https://www.thenorthface.com/en_ca/homepage.html';
    }

    return (
        <div id="sid-step-success" className="sid-l-container">
            <div className="sid-header sid-l-horz-center sid-l-space-top-md">
                <div className="sid-header__title sid-l-horz-center sid-l-space-top-md">
                    <FormattedHTMLMessage id="step.success.title" defaultMessage="SUCCESS! YOU'VE BEEN VERIFIED!" />
                </div>
                <div className="sid-header__subtitle sid-l-horz-center sid-l-two-thirds-width">
                    <FormattedHTMLMessage id="step.success.subtitle"
                        defaultMessage="Here is your Promo Code:"/>
                </div>
            </div>

            <div className="sid-reward-code sid-l-space-top-lg sid-h-jumbo-text sid-l-horz-center">
                {rewardCode}
            </div>

            <div className="sid-l-space-top-md sid-h-bold-text sid-l-horz-center">
                <CopyToClipboard
                    textToCopy={rewardCode}
                >
                    <FormattedHTMLMessage id="step.success.copyCouponCode" defaultMessage="Copy Coupon code" />
                </CopyToClipboard>
            </div>

            <div className="sid-l-space-top-lg sid-redeem-instructions">
                <FormattedHTMLMessage id="step.success.toRedeemTitle" defaultMessage="To Redeem:"/>
                <ol className="sid-redeem-instructions__bullets">
                    <li>
                        <FormattedHTMLMessage id="step.success.toRedeem1" defaultMessage='Click the \"Apply a Promo Code\" link listed directly below your Shopping Cart. Note: Your code must be applied BEFORE checkout and can only be used once.'/>
                    </li>
                    <li>
                        <FormattedHTMLMessage id="step.success.toRedeem2" defaultMessage="To Redeem:"/>
                    </li>
                </ol>
            </div>

            <div className="sid-footer sid-l-horz-center sid-l-space-top-lg">
                <FormattedHTMLMessage id="step.success.emailNotification" defaultMessage={`
                    We've also emailed you a copy of this code so it can be used later. Look for an email from verify@sheerid.com
                `} />
            </div>

            <div className="sid-submit sid-l-space-top-md">
                <button
                    onClick={() => redirect(redirectUrl)}
                    className="sid-btn sid-btn--dark"
                >
                    <FormattedHTMLMessage id="step.success.redirectButtonText" defaultMessage="CONTINUE" />
                </button>
            </div>

            <div className="sid-footer sid-l-horz-center sid-l-space-top-lg sid-h-small-text">
                <FormattedHTMLMessage id="step.success.verificationOnly"
                    defaultMessage="SheerID handles verification only. Now that you've been approved, please direct all questions about the promotion terms and/or code use to The North Face customer service."
                />
            </div>
        </div>
    );
};

export { StepSuccessComponent };
